<template>
  <div class="editar_perfil configuracoes">
    <div class="descTable">
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <h2 style="color:white; box-shadow: 1px 1px 8px black;">
            <svg
              style="width:24px;height:24px; margin-left: 87px;margin-bottom: -4px;"
              viewBox="0 0 24 24"
            >
              <path
                fill="#FFF"
                d="M19.43,12.97L21.54,14.63C21.73,14.78 21.78,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.03 19.05,18.95L16.56,17.94C16.04,18.34 15.5,18.67 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.78,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,12.97M6.5,12C6.5,12.58 6.59,13.13 6.75,13.66L4.68,15.36L5.43,16.66L7.95,15.72C8.69,16.53 9.68,17.12 10.8,17.37L11.24,20H12.74L13.18,17.37C14.3,17.13 15.3,16.54 16.05,15.73L18.56,16.67L19.31,15.37L17.24,13.67C17.41,13.14 17.5,12.58 17.5,12C17.5,11.43 17.41,10.87 17.25,10.35L19.31,8.66L18.56,7.36L16.06,8.29C15.31,7.47 14.31,6.88 13.19,6.63L12.75,4H11.25L10.81,6.63C9.69,6.88 8.69,7.47 7.94,8.29L5.44,7.35L4.69,8.65L6.75,10.35C6.59,10.87 6.5,11.43 6.5,12M12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5M12,10.5A1.5,1.5 0 0,0 10.5,12A1.5,1.5 0 0,0 12,13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 12,10.5Z"
              ></path>
            </svg>
            Configurações da conta
            <transition name="slide-fade">
              <v-icon v-if="!empresa._id" class="mr-2 ml-2 loading fechamento_loop">loop</v-icon>
            </transition>
          </h2>
        </v-flex>
      </v-layout>
    </div>

    <v-tabs
      v-if="empresa._id"
      slider-color="indigo darken-4"
      left
      v-model="currentItem"
      id="containerTab"
      class="tabPerfil"
      color="grey lighten-5"
    >
      <v-tab
        id="tabOption"
        v-for="(item,i) in tabs"
        :key="i"
        :class="[i == currentItem ? 'active' : '']"
      >{{ item.title }}</v-tab>
      <v-tab-item>
        <!-- TAB DE EMPRESAS -->
        <v-card flat v-if="this.currentItem == 0">
          <v-card-text>
            <v-tooltip bottom>
            <v-btn
              slot="activator"
              outline
              color="black"
              text-color="white"
              dark
              class="d-inline-block"
              @click.native="showFormCadastrar('Empresa')"
            >
              <v-icon
                class="material-icons"
                dark
                color="teal"
                style="padding-right: 10px;font-size: 13px!important;position: absolute;left: -8%;"
              >add</v-icon>
              <v-icon class="material-icons" dark color="teal" style="padding-right: 10px;">domain</v-icon>
              <small>Adicionar empresa</small>
            </v-btn>
            <span>Adicionar uma nova empresa</span>
            </v-tooltip>

            <v-tooltip bottom>
              <v-btn
                slot="activator"
                outline
                color="black"
                text-color="white"
                dark
                class="d-inline-block"
                @click.native="dialog2 = !dialog2"
              >
                <v-icon
                  class="material-icons"
                  dark
                  color="teal"
                  style="padding-right: 10px;"
                >person_add</v-icon>
                <small>Adicionar Colaborador</small>
              </v-btn>
              <span>Adicionar um novo colaborador</span>
            </v-tooltip>

            <v-dialog
              v-if="dialog2"
              @keydown.esc="dialog2 = false"
              v-model="dialog2"
              @keydown.enter="salvarDados()"
              max-width="700px"
              transition="dialog-bottom-transition"
            >
              <v-card>
                <v-toolbar dark class="headline darkBlue">
                  <v-toolbar-title>Configuração do Colaborador</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon dark @click.native="dialog2 = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-toolbar>
                <article>
                  <v-subheader subheader class=".container">
                    <h2>Adicionar Colaborador</h2>
                  </v-subheader>
                  <FormUsuario
                    :displayFlex="'xs6 sm6 md6'"
                    :conta="this.conta"
                    :create="true"
                    :resetForm="resetForm"
                    :formEmp="true"
                    :getDadosForm="getDadosForm"
                    @changResetForm="changResetForm($event)"
                    @emitDadosForm="emitDadosForm($event)"
                  ></FormUsuario>
                  <v-container grid-list-md text-xs-center>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-btn
                          block
                          outline
                          depressed
                          small
                          color="red"
                          @click.native="dialog2 = false"
                        >Cancelar</v-btn>
                      </v-flex>
                      <v-flex xs6>
                        <v-btn
                          block
                          depressed
                          class="white--text"
                          small
                          color="teal"
                          @click.native="salvarDados()"
                        >Cadastrar</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </article>
              </v-card>
            </v-dialog>

            <article>
              <v-layout row justify-center>
                <v-dialog
                  v-if="dialog2 != true"
                  persistent
                  v-model="dialog"
                  max-width="700px"
                  transition="dialog-bottom-transition"
                >
                  <v-card>
                    <v-toolbar dark class="headline darkBlue">
                      <v-toolbar-title>Configuração da Empresa - {{formEmp.titulo}}</v-toolbar-title>
                      <v-spacer></v-spacer>

                      <v-btn icon dark @click.native="dialog = false">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <article>
                      <!-- <v-subheader subheader class=".container"><h2></h2></v-subheader> -->
                      <FormEmpresa
                        :conta="this.conta"
                        :currentTab="this.currentTabInComp"
                        :resetForm="resetForm"
                        :getDadosForm="getDadosForm"
                        :IBGE="this.IBGE"
                        @changResetForm="changResetForm($event)"
                        @emitDadosForm="emitDadosForm($event)"
                        :edit="edit"
                        :empEdit="empEdit"
                        :notificacoes="this.notificacoes"
                      ></FormEmpresa>
                      <v-container grid-list-md text-xs-center style="padding-top: 2px;">
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-btn
                              block
                              outline
                              depressed
                              small
                              color="red"
                              @click.native="dialog = false"
                            >Cancelar</v-btn>
                          </v-flex>
                          <v-flex xs6>
                            <v-btn
                              block
                              depressed
                              class="white--text"
                              small
                              color="teal"
                              @click.native="salvarDados()"
                            >{{formEmp.btnSuccess}}</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </article>
                  </v-card>
                </v-dialog>
              </v-layout>
            </article>
            <div class="cardPerfil">
              <div class="cardPerfil-body">
                <RenderTableNFe
                  :conta="this.conta"
                  :alert="this.alert"
                  :IBGE="this.IBGE"
                  :sendAttTable="this.sendAttTable"
                  @attSendTable="attSendTable($event)"
                  @emitEditEmp="emitEditEmp($event)"
                  :table="'empresa'"
                ></RenderTableNFe>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <!-- TAB DE CERTIFICADOS -->
        <v-card flat v-if="this.currentItem == 1">
          <v-card-text>
            <v-tooltip bottom>
            <v-btn
              slot="activator"
              outline
              color="black"
              text-color="white"
              dark
              class="d-inline-block"
              @click.native="showFormCadastrar('Certificado')"
            >
              <v-icon
                class="material-icons"
                dark
                color="teal"
                style="padding-right: 10px;font-size: 13px!important;position: absolute;left: -8%;"
              >add</v-icon>
              <svg
                style="width: 15px;height: 17px;margin-top: 2px;"
                class="customIcon i_header"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#000000"
                  d="M4,3C2.89,3 2,3.89 2,5V15A2,2 0 0,0 4,17H12V22L15,19L18,22V17H20A2,2 0 0,0 22,15V8L22,6V5A2,2 0 0,0 20,3H16V3H4M12,5L15,7L18,5V8.5L21,10L18,11.5V15L15,13L12,15V11.5L9,10L12,8.5V5M4,5H9V7H4V5M4,9H7V11H4V9M4,13H9V15H4V13Z"
                ></path>
              </svg>
              <small>Adicionar certificado</small>
            </v-btn>
            <span>Adicionar um novo certificado</span>
            </v-tooltip>

            <article>
              <v-layout row justify-center>
                <v-dialog
                  persistent
                  v-if="dialog2 != true"
                  @keydown.esc="dialog = false"
                  @keydown.enter="salvarDados()"
                  v-model="dialog"
                  max-width="600px"
                  transition="dialog-bottom-transition"
                >
                  <v-card>
                    <v-toolbar dark class="headline darkBlue">
                      <v-toolbar-title>Configuração do Certificado</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn icon dark @click.native="dialog = false">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <article>
                      <v-subheader subheader class=".container">
                        <h2>{{formEmp.titulo}}</h2>
                      </v-subheader>
                      <FormCertificado
                        :displayFlex="'xs12 sm12 md12'"
                        :conta="this.conta"
                        :create="true"
                        :resetForm="resetForm"
                        :getDadosForm="getDadosForm"
                        @changResetForm="changResetForm($event)"
                        @emitDadosForm="emitDadosForm($event)"
                      ></FormCertificado>
                      <v-container grid-list-md text-xs-center>
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-btn
                              block
                              outline
                              depressed
                              small
                              color="red"
                              @click.native="dialog = false"
                            >Cancelar</v-btn>
                          </v-flex>
                          <v-flex xs6>
                            <v-btn
                              block
                              depressed
                              class="white--text"
                              small
                              color="teal"
                              text-color="white"
                              @click.native="salvarDados()"
                            >{{formEmp.btnSuccess}}</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </article>
                  </v-card>
                </v-dialog>
              </v-layout>
            </article>

            <v-container v-if="formEmp.show" class="panelFiltro">
              <div class="descTable">
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <h2 style="color:white; margin-left: 1em;">{{formEmp.titulo}}</h2>
                  </v-flex>
                </v-layout>
              </div>
              <v-layout row wrap></v-layout>
            </v-container>

            <div class="cardPerfil">
              <div class="cardPerfil-body">
                <RenderTableNFe
                  :conta="this.conta"
                  :alert="this.alert"
                  :IBGE="this.IBGE"
                  :sendAttTable="this.sendAttTable"
                  @attSendTable="attSendTable($event)"
                  @emitEditEmp="emitEditEmp($event)"
                  :table="'certificado'"
                ></RenderTableNFe>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
    <v-card-text></v-card-text>
  </div>
</template>

<script>
import RenderTableNFe from "@/components/dataTable/RenderTableNFe.vue";
import FormUsuario from "@/components/conta/usuario/formUsuario/FormUsuario.vue";
import FormEmpresa from "@/components/conta/empresa/formEmpresa/FormEmpresa.vue";
import FormCertificado from "@/components/conta/empresa/certificado/formCertificado/FormCertificado.vue";
import EmpresaService from "@/domain/conta/empresa/EmpresaService.js";
import UsuarioService from "@/domain/conta/usuario/UsuarioService.js";
import CertificadoService from "@/domain/conta/empresa/certificado/CertificadoService.js";
import TableEmpresas from "@/domain/dataTable/TableEmpresas";
export default {
  props: ["empresa", "alert", "conta", "IBGE"],
  components: {
    RenderTableNFe: RenderTableNFe,
    FormUsuario: FormUsuario,
    FormEmpresa: FormEmpresa,
    FormCertificado: FormCertificado
  },
  data() {
    return {
      dialog: false,
      dialog2: false,
      sendAttTable: false,
      resetForm: false,
      formEmp: { show: false, titulo: "", btnSuccess: "" },
      route: this.$router.history.current.path,
      currentItem: "",
      empEdit: {},
      edit: false,
      currentTabInComp: undefined,
      getDadosForm: false,
      tabs: [
        {
          title: "Empresas"
        },
        {
          title: "Certificado"
        }
      ],
      notificacoes: {
        objetos: []
      }
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      if (this.$session.exists()) {
        if (this.$session.get("jwt").gravatarProfile != undefined) {
          this.avatarProfile =
            this.$session.get("jwt").gravatarProfile.thumbnailUrl + "?s=200";
        }
      }
    });
  },
  updated: function() {},
  watch: {
    dialog: function(newV, oldV) {
      if (!newV) {
        this.edit = newV;
      }
    }
  },
  computed: {},
  methods: {
    emitEditEmp($event) {
      this.notificacoes.objetos = [];
      this.formEmp.titulo = "Editar Empresa: ";
      this.formEmp.btnSuccess = "Salvar";
      this.empEdit = $event;
      this.notificacoes.objetos = $event.enviaEmails.slice();
      this.edit = true;
      this.dialog = true;
    },
    showFormCadastrar(tipo) {
      this.formEmp.titulo = `Cadastro de ${tipo}:`;
      this.formEmp.btnSuccess = "Cadastrar";
      this.empEdit = {};
      this.edit = false;
      this.resetForm = true;
      this.dialog = true;
      this.notificacoes.objetos = [];
    },
    salvarDados() {
      this.getDadosForm = true;
    },
    changResetForm(value) {
      this.resetForm = value;
    },
    emitAttEmpresas() {
      this.$emit("emitAttEmpresas", true);
    },
    emitDadosForm: async function(value) {
      let envDados = false;
      this.alert.resetAlert();
      if (value != false) {
        if (value.tipo.component == "empresa") {
          this.service = new EmpresaService(this.$http);
        } else if (value.tipo.component == "usuario") {
          this.service = new UsuarioService(this.$http);
        } else if (value.tipo.component == "certificado") {
          this.service = new CertificadoService(this.$http);
        } else {
          throw new Error("Serviço de configuração não codificado");
        }
        envDados = true;
      } else {
        this.currentTabInComp = 0;
        this.alert.snackAlert();
        this.alert.snack.text = "Verificamos que possuem campos com erros.";
        this.alert.snack.show = true;
      }
      if (envDados) {
        await this.envDadosApi(value);
      }
      this.getDadosForm = false;
      this.resetForm = false;
    },
    envDadosApi: async function(value) {
      let method;
      let id;

      //metodos variam de acordo com ação. Tanto empresa,certificado,usúario possuem opções de cadastrar/editar em seus serviços.
      //id variam de acordo com o metodo, se for editar, no form do componente estará atrelado o id para edição. Criação o id tem que ser vinculado a conta.
      value.tipo.acao == "create"
        ? (id = this.conta.conta)
        : (id = value.dados._id);
      value.tipo.acao == "create"
        ? (method = "cadastrar")
        : (method = "editar");

      let body = {};
      if (value.tipo.component == "usuario") {
        body["colaborador"] = value.dados;
        body["empresas"] = value.empresas;
      } else if (value.tipo.component == "empresa") {
        let notificacoes = [];
        this.notificacoes.objetos.forEach(curr => {
          if (!curr.hasOwnProperty("delete") || curr["delete"] == false) {
            notificacoes.push(curr);
          }
        });       
        value.dados["enviaEmails"] = notificacoes;
        body = value.dados;
      } else {
        body = value.dados;
      }
      await this.service[method](body, id)
        .then(async function(resp) {
          //adicionar empresa cadastrada na conta.
          if (resp.body.hasOwnProperty("empresas")) {
            let currentEmp = undefined;
            resp.body.empresas.forEach(emp => {
              if (emp.empresa.hasOwnProperty("_id")) {
                currentEmp = emp.empresa;
              }
            });
            if (currentEmp) {
              this.conta.admin.push(currentEmp);
            }
          }
          this.alert.snackDanger();
          resp.body.message != undefined && resp.body.message.length != 0
            ? (this.alert.snack.text = resp.body.message)
            : (this.alert.snack.text = resp.infoMessage.msg);
          if (resp.ok && value.tipo.component != "empresa") {
            this.alert.snackSuccess();
            this.dialog = false;
            this.dialog2 = false;
            this.edit = false;
            return;
          }
          //lógica para cadastrar um certificado junto a empresa na sua criação.
          if (value.tipo.component == "empresa") {
            if (resp.ok) {
              //necessario pois ao cadastrar uma empresa e alguma informação do certificado estivesse errada ele retornaria um erro que a 'empresa já estava cadastrada'
              this.alert.snackSuccess();
            }
            const data = new FormData();
            if (value.cert != false && value.cert.dados.file != undefined) {
              data.append("file", value.cert.dados.file[0]);
              data.append("password", value.cert.dados.password);
            }
            await this.service
              .getEmpresasCnpj(value.dados.cnpj)
              .then(async function(res) {
                if (value.cert != false) {
                  value.cert.dados["empresa"] = res.body.items[0]._id;
                  value.cert.dados.file = data.get("file");
                  value.cert.dados.password = data.get("password");
                }

                this.service = new CertificadoService(this.$http);
                if (value.cert != false && value.cert.dados.file != undefined) {
                  let arrayEmp = [];
                  arrayEmp.push(value.cert.dados.empresa);
                  value.cert.dados["empresa"] = arrayEmp;
                  
                  await this.service
                    .cadastrar(value.cert.dados, this.conta.conta)
                    .then(resp => {
                      if (resp.ok) {
                        this.alert.snackSuccess();
                        this.dialog = false;
                        this.edit = false;
                      } else {
                        this.alert.snackDanger();
                        resp.body.message != undefined &&
                        resp.body.message.length != 0
                          ? (this.alert.snack.text = resp.body.message)
                          : (this.alert.snack.text = resp.infoMessage.msg);
                      }
                    });
                } else if (
                  value.cert != false &&
                  value.cert.dados._id != undefined
                ) {
                  this.service = new CertificadoService(this.$http);
                  let arrayEmp = [];
                  arrayEmp.push(res.body.items[0]._id);
                  await this.service
                    .vincularEmpresa(value.cert.dados._id, arrayEmp)
                    .then(resp => {
                      if (resp.ok) {
                        this.alert.snackSuccess();
                        this.dialog = false;
                        this.edit = false;
                      } else {
                        this.alert.snackDanger();
                        resp.body.message != undefined &&
                        resp.body.message.length != 0
                          ? (this.alert.snack.text = resp.body.message)
                          : (this.alert.snack.text = resp.infoMessage.msg);
                      }
                    });
                } else {
                  this.dialog = false;
                  this.edit = false;
                }
                return res.body.items[0].cnpj;
              });
          } else {
            this.dialog = false;
            this.edit = false;
          }
        })
        .then(v => {
          this.emitAttEmpresas();
          this.conta.getEmpresas = true;
        })
        .then(v => {
          this.sendAttTable = true;
          this.alert.snack.show = true;
        });
    },
    attSendTable(value) {
      this.sendAttTable = value;
    }
  },
  beforeMount: function() {
    this.$nextTick(function() {});
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component.name only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  text-decoration: none;
  color: #42b983;
}
.iconCloud {
  transform: rotate(180deg);
}
#panelEmpresa {
  padding: 30px 0;
  background: #e3f2fd;
}
#panelEmpresa h1 {
  font-family: "Quicksand", sans-serif;
}

#containerTab div.v-tabs__container {
  margin-left: 35px !important;
}
.v-tabs__container {
  background-color: #fafafa !important;
}
.v-tabs__bar {
  padding-top: 35px !important;
}
.v-card__text {
  padding-top: 0 !important;
}
#tabOption.active {
  background-color: white;
}
.descTable {
  background-color: rgb(0, 150, 136) !important;
  margin: 0 0 39px 0px;
}
.descTable.cte {
  margin: 0 0 50px 0px;
}
.cardPerfil {
  margin: 0;
}
.cardPerfil-title {
  background-color: lightgrey;
  padding: 15px;
  border-radius: 11px 11px 0 0;
  font-weight: 600;
  color: #5d5d5d;
}
.cardPerfil-img {
  width: 15%;
  display: inline-block;
  text-align: center;
}
.cardPerfil-img img {
  border-radius: 50%;
  width: 72px;
  height: 72px;
  text-align: center;
}

.cardPerfil-body {
  background-color: white;
  padding: 7px;
}
.vinculoChip span.v-chip__content {
  cursor: pointer;
  font-size: 10px !important;
}
.fundo_destaque {
  background-color: whitesmoke;
  padding: 5px;
}
.configuracoes h2 {
  font-weight: normal;
  background-color: teal;
}
.configuracoes .fechamento_loop {
  font-size: 22px;
  font-weight: bold;
  color: cyan;
}
.loading {
  animation-name: loading;
  animation: loading 2s infinite;
}
@media(max-width: 600px) {
    .card_loja {
        grid-template-columns: 1fr;
    }
}
@-webkit-keyframes loading {
  from {
    transform: rotate(0) scaleX(-1);
  }
  to {
    transform: rotate(180deg) scaleX(-1);
  }
}

@keyframes loading {
  from {
    transform: rotate(0) scaleX(-1);
  }

  to {
    transform: rotate(180deg) scaleX(-1);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/loggedArea/configuracoes/Configuracoes.vue